import { render, staticRenderFns } from "./ToggleItem.vue?vue&type=template&id=38e5a730&scoped=true"
import script from "./ToggleItem.vue?vue&type=script&lang=js"
export * from "./ToggleItem.vue?vue&type=script&lang=js"
import style0 from "./ToggleItem.vue?vue&type=style&index=0&id=38e5a730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e5a730",
  null
  
)

export default component.exports